export const SERVICE_FEE_RATE = 0.1;

export interface PriceBreakdown {
  days: number;
  dailyRate: number;
  subtotal: number;
  serviceFee: number;
  total: number;
}

export function computeBreakdown(dailyRate: number, days: number): PriceBreakdown {
  const safeDays = Math.max(1, Math.round(days) || 0);
  const subtotal = Math.round(dailyRate * safeDays);
  const serviceFee = Math.round(subtotal * SERVICE_FEE_RATE);
  return {
    days: safeDays,
    dailyRate,
    subtotal,
    serviceFee,
    total: subtotal + serviceFee,
  };
}

export function normalizePhone(input: string): string {
  const digits = (input || "").replace(/[^\d]/g, "");
  if (digits.startsWith("254")) return digits;
  if (digits.startsWith("0")) return `254${digits.slice(1)}`;
  if (digits.startsWith("7") || digits.startsWith("1")) return `254${digits}`;
  return digits;
}

export function isValidKenyanPhone(input: string): boolean {
  const normalized = normalizePhone(input);
  return /^254(7|1)\d{8}$/.test(normalized);
}